import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as selectors from '../../store/reducers';
import { PermissionDto } from '@careapp-group/ng-sdk';

@Directive({
    selector: '[hasQualification]',
    standalone: false
})
export class HasQualificationDirective implements OnInit, OnDestroy {
  qualificationConfig: { qualification: string; value: string };
  userRoles: PermissionDto[];

  private showing = true;

  sub: Subscription;

  constructor(
    public store: Store<any>,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
    this.sub = this.store.select(selectors.org.currentOrgPermissions).subscribe((roles) => {
      this.userRoles = (roles || []).slice();
      this._updateView();
    });
  }

  @Input()
  set hasQualification(qualificationConfig: { [key: string]: any }) {
    if (
      Array.isArray(qualificationConfig) ||
      (qualificationConfig && Object.keys(qualificationConfig).length > 1)
    ) {
      throw new Error(
        `Provide only a single key/value pair or undefined/null to *hasQualification`
      );
    }

    if (qualificationConfig) {
      const qualification = Object.keys(qualificationConfig)[0];
      const value = qualificationConfig[qualification];
      this.qualificationConfig = {
        qualification,
        value,
      };
    } else {
      this.qualificationConfig = null;
    }
    this._updateView();
  }

  private _hasMatchingQualification() {
    if (!this.userRoles || !this.userRoles.length) {
      return false;
    }
    if (!this.qualificationConfig) {
      return false;
    }

    const matchingQualification = this.userRoles.find(
      (role) =>
        (role.qualifications || {})[this.qualificationConfig.qualification] ===
        this.qualificationConfig.value
    );

    return !!matchingQualification;
  }

  private _updateView() {
    const hasQualification = this._hasMatchingQualification();
    if (hasQualification) {
      this.show();
    } else {
      this.hide();
    }
  }

  ngOnInit() {
    this.viewContainerRef.clear();
  }

  private show() {
    if (!this.showing) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.showing = true;
    }
  }

  private hide() {
    if (this.showing) {
      this.viewContainerRef.clear();
      this.showing = false;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
